export default __webpack_public_path__ + "static/media/contabilita-dark.dea58631.svg";